import {
    authentication,
    authenticationDevice,
    authenticationEmpMode,
    clearToken,
    setO365TokenCookie,
    setUserImageCookie,
    setDataArea,
    setUrlIncoming
} from '../../lib/auth'

const AuthManager = {
    setCookie(data) {
        authentication(data)
    },
    setDeviceCookie(data) {
        authenticationDevice(data)
    },
    setCookieEmp(data) {
        authenticationEmpMode(data)
    },
    setO365TokenCookie(data) {
        setO365TokenCookie(data)
    },
    setUserImageCookie(blob) {
        setUserImageCookie(blob)
    },
    setDataArea(area) {
        setDataArea(area)
    },
    setUrlIncoming(url) {
        setUrlIncoming(url)
    },
    logout(callBack = null) {
        clearToken()
        if (callBack) {
            return callBack
        } else {
            return false
        }
    }
}
export default AuthManager



// WEBPACK FOOTER //
// ./src/app/business/authManager.js